import questionnaireExamineList from './questionnaireExamineList.vue';
import myQuestionnaireExamineList from './myQuestionnaireExamineList.vue';
import { questionnaireExamineListData } from './request';
export default {
  components: {
    questionnaireExamineList,
    myQuestionnaireExamineList
  },
  data() {
    return {
      current: 1,
      num: 0
    };
  },
  created() {
    this.getNumFun();
  },
  methods: {
    getNumFun() {
      questionnaireExamineListData({
        page: 1,
        pageSize: 1,
        status: 'PASSED',
        type: 'checkPending'
      }).then(res => {
        this.num = res.totalNum;
      });
    }
  }
};